import { IGeneralRedux } from "../../../common/models/response";
import {
  IAgentListResponse,
  IAgentShareCommissionResponse,
  IShareAgentInfoResponse,
} from "../response";

export interface IAgentReduxState extends IGeneralRedux {
  agentList: IAgentListResponse | null;
  agentInfo: IShareAgentInfoResponse | null;
  agentShareCommission: IAgentShareCommissionResponse | null;
}

export const agentState: IAgentReduxState = {
  agentShareCommission: null,
  agentList: null,
  agentInfo: null,
  actionsLoading: false,
  listLoading: false,
  searchLoading: false,
};
